import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	customLinkItem: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		marginRight: "6px",
		color: colors.blue[700],
		fontWeight: "normal",
		borderRadius: "4px"
	},
	customLinkItemDeleteIcon: {
		color: colors.red[400],
		fontSize: "20px"
	},
	linkDisplayText: {
		color: colors.blue[700]
	}
})

export default useStyles
